import {
  Box,
  Button,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getglobalStoreObject, setState } from "../Stores/globalStore";
import {
  createDocument,
  getDocument,
  setApiKey,
  setProjectId,
} from "../Repos/Sanity";
import { CheckIcon, SmallCloseIcon, SpinnerIcon } from "@chakra-ui/icons";
import { formatDate, generateUniqueOrderNum } from "../Repos/Utils";
import { useNavigate } from "react-router-dom";

function Login() {
  const guestUser = {
    _type: "user_profile",
    userName: "guest",
    password: "guestPassword",
    expireDate: formatDate(new Date()),
    menuSymbols: ["SPY", "NVDA"],
  };

  const navigate = useNavigate();
  const toast = useToast();

  const globalStore = useSelector(getglobalStoreObject);
  const _dispatch = useDispatch();

  const [userName, setuserName] = React.useState("");
  const [password, setpassword] = React.useState("");
  const [confirmPassword, setconfirmPassword] = React.useState("");

  const [isValidUser, setisValidUser] = React.useState("none");

  const performLogin = (_user) => {
    _dispatch(
      setState({
        user_profile: { ..._user },
      })
    );
    navigate("/");
  };
  React.useEffect(() => {
    _dispatch(setState({ firstEntrancePassed: true }));
    document.title = "LogIn";
    setApiKey(
      "skyNnxaBMfOPznIa32XQxHxJkKQEYG2zdMrN82Hqc9131SBtE4gl8srafIaRLLALbFzlOXc077C7PF321chwROE25sQViJD0yuo8uDq2AnJujyniIZDUbhQ292oCvpUyJuLqNt3cbh0tOeznMFpnVVg4ygBWQmbCjobUuqZ463OLZ6jOtMxh"
    );
    setProjectId("m418ryo9");

    // console.log(
    //   "checking if i will be loaded as gues user",
    //   !!!globalStore.firstEntrancePassed
    // );

    //automatically login if we have user and password saved in localstorage
    var storedUserName = "";
    var storedPassword = "";
    storedUserName = localStorage.getItem("SI_UserName");
    storedPassword = localStorage.getItem("SI_Password");
    // console.log("checking automatic loggin in", storedUserName, storedPassword);
    if (storedUserName != null && storedPassword != null) {
      getDocument(
        {
          _type: "user_profile",
          userName: storedUserName,
          password: storedPassword,
        },
        (_res) => {
          if (_res.length > 0) {
            // console.log("user fetched", _res[0]);
            if (_res[0].password == storedPassword) {
              performLogin(_res[0]);
            }
          } else {
            toast({
              title: "Authentication Warning",
              description: "Invalid username or password.",
              status: "error",
              duration: 9000,
              isClosable: true,
            });
          }
        },
        ["..."],
        true
      );
    } else {
      if (!!!globalStore.firstEntrancePassed) {
        performLogin(guestUser);
      }
    }

    return () => {};
  }, []);

  return (
    <Box width={"100%"}>
      <Box h={"15vh"}></Box>
      <Box justifyItems={"center"}>
        <Box
          justifyItems={"center"}
          w={globalStore.isMobile ? "90%" : "40%"}
          p={2}
          borderRadius={"md"}
          border={"1px"}
          borderRight={"4px"}
          borderBottom={"4px"}
          borderColor={"gray.500"}
        >
          <Text fontSize={"xl"} fontWeight={"bold"} color={"blue.700"} mb={10}>
            {"LogIn or Create a New Account"}
          </Text>
          {/* inputs texts */}
          <Box mb={5}>
            {/* username */}
            <Box p={2}>
              <InputGroup>
                <InputRightElement>
                  {/* {isValidUser == "no" ? (
                    <SmallCloseIcon></SmallCloseIcon>
                  ) : (
                    <></>
                  )} */}
                  {isValidUser == "checking" ? (
                    <SpinnerIcon></SpinnerIcon>
                  ) : (
                    <></>
                  )}
                  {isValidUser == "yes" ? <CheckIcon></CheckIcon> : <></>}
                </InputRightElement>
                <Input
                  value={userName}
                  onChange={(_e) => setuserName(_e.target.value)}
                  placeholder="1. userName"
                  size="md"
                  onBlur={() => {
                    //check if user exists
                    if (userName.trim() == "") {
                      return;
                    }
                    setisValidUser("checking");
                    var asyncFunction = async () => {
                      getDocument(
                        { _type: "user_profile", userName: userName },
                        (_res) => {
                          if (_res.length > 0) {
                            setisValidUser("yes");
                            // console.log("users", _res);
                          } else {
                            setisValidUser("no");
                          }
                        },
                        ["userName"],
                        true
                      );
                    };
                    asyncFunction();
                  }}
                />
              </InputGroup>
              <Text color={"gray.500"} fontSize={"sm"} ml={3}>
                {" * careful, it is case sensitive"}
              </Text>
            </Box>
            {/* password */}
            {["no", "yes"].includes(isValidUser) ? (
              <Box p={2}>
                <Input
                  value={password}
                  onChange={(_e) => setpassword(_e.target.value)}
                  placeholder="2. insert password"
                  size="md"
                  type={"password"}
                />
              </Box>
            ) : (
              <></>
            )}
            {/* confirm password */}
            {["no"].includes(isValidUser) ? (
              <Box p={2}>
                <Input
                  value={confirmPassword}
                  onChange={(_e) => setconfirmPassword(_e.target.value)}
                  placeholder="3. confirm password"
                  size="md"
                  type={"password"}
                />
              </Box>
            ) : (
              <></>
            )}
          </Box>
          {/* buttons */}
          <Box>
            {/* continue */}
            {["none"].includes(isValidUser) ? (
              <Box p={2}>
                <Button
                  borderRadius={"md"}
                  border={"1px"}
                  borderRight={"4px"}
                  borderBottom={"4px"}
                  borderColor={"green.500"}
                  onClick={() => {
                    if (userName == "") {
                      toast({
                        title: "Compilation Warning",
                        description: "Invalid email.",
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                      });
                    }
                  }}
                >
                  Continue
                </Button>
              </Box>
            ) : (
              <></>
            )}
            {/* register */}
            {["no"].includes(isValidUser) ? (
              <Box p={2}>
                <Button
                  borderRadius={"md"}
                  border={"1px"}
                  borderRight={"4px"}
                  borderBottom={"4px"}
                  borderColor={"green.500"}
                  onClick={() => {
                    if (userName == "") {
                      toast({
                        title: "Compilation Warning",
                        description: "Invalid email.",
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                      });
                    }

                    if (password == "") {
                      toast({
                        title: "Compilation Warning",
                        description: "Invalid password.",
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                      });
                      return;
                    }

                    if (password != confirmPassword) {
                      toast({
                        title: "Compilation Warning",
                        description: "Passwords not corresponding.",
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                      });
                      return;
                    }
                    if (userName.toUpperCase() == "GUEST") {
                      toast({
                        title: "Compilation Warning",
                        description: "Username cannot be the word 'guest'.",
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                      });
                      return;
                    }

                    const newUser = {
                      _type: "user_profile",
                      userName,
                      password,
                      expireDate: formatDate(new Date()),
                      menuSymbols: ["SPY", "NVDA"],
                    };
                    createDocument(newUser, () => {
                      performLogin(newUser);
                    });
                  }}
                >
                  Register
                </Button>
              </Box>
            ) : (
              <></>
            )}
            {/* login */}
            {["yes"].includes(isValidUser) ? (
              <Box p={2}>
                <Button
                  borderRadius={"md"}
                  border={"1px"}
                  borderRight={"4px"}
                  borderBottom={"4px"}
                  borderColor={"green.500"}
                  onClick={() => {
                    if (userName == "") {
                      toast({
                        title: "Compilation Warning",
                        description: "Invalid email.",
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                      });
                      return;
                    }
                    if (password == "") {
                      toast({
                        title: "Compilation Warning",
                        description: "Invalid password.",
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                      });
                      return;
                    }
                    getDocument(
                      { _type: "user_profile", userName, password },
                      (_res) => {
                        if (_res.length > 0) {
                          if (_res[0].password == password) {
                            localStorage.setItem(
                              "SI_UserName",
                              _res[0].userName
                            );
                            localStorage.setItem(
                              "SI_Password",
                              _res[0].password
                            );
                            performLogin(_res[0]);
                          }
                        } else {
                          toast({
                            title: "Authentication Warning",
                            description: "Invalid username or password.",
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                          });
                        }
                      },
                      ["..."],
                      true
                    );
                  }}
                >
                  Login
                </Button>
              </Box>
            ) : (
              <></>
            )}
          </Box>

          <Box mt={5}>
            <Text
              textDecoration="underline"
              cursor="pointer"
              onClick={() => {
                performLogin(guestUser);
              }}
            >
              {"Enter as guest"}
            </Text>
          </Box>

          <Box mt={5}>
            <Text
              textDecoration="underline"
              cursor="pointer"
              onClick={() => {
                navigate("/help");
              }}
            >
              {"Forgot username or password"}
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Login;
